import { createFourierModel } from "./model";
import { dinosaur } from "./shapes/dinosaur";
import { DINOSAUR_MODEL_SIZE, DINOSAUR_CIRCLE_COUNTS } from "./dinosaurTheme";

export const dinosaurModel = createFourierModel(dinosaur, DINOSAUR_MODEL_SIZE, DINOSAUR_CIRCLE_COUNTS);
